import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Component({
  selector: 'app-assign-reviewer',
  templateUrl: './assign-reviewer.component.html',
  styleUrls: ['./assign-reviewer.component.scss'],
})
export class AssignReviewerComponent implements OnInit {
  ID: number;
  Email: string;
  Name: string;
  Degree: string;
  Diploma: string;
  Certificate: string;

  displayedColumns: string[] = [
    'ID',
    'Email',
    'Name',
    'Degree',
    'Diploma',
    'Certificate',
  ];
  dataSource = [];
  public loading = false;
  
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );
  constructor(private breakpointObserver: BreakpointObserver) {}

  ngOnInit(): void {
    this.loading = true;
    setTimeout(()=>{
        // const msg ='Loading...';
         this.loading  = false;
    }, 3000)
  }
}
